import { VisibilityState } from "@tanstack/react-table";

export const columnVisibilityItems: VisibilityState = {
  // SYSTEM / INTERNAL FIELDS
               // already hidden
  password: false,          // sensitive
  user_id: false,           // internal UUID
  student_id_user: false,   // internal or redundant
  user_identifier: false,   // system-level identifier
  updated_at: false,        // timestamp, not always needed
  created_at: false,        // timestamp, not always needed
  student_id: false,        // general student ID (ambiguous usage)

  // PROFILE
  cid: false,               // national ID — sensitive
  user_profile_id: false,   // profile UUID — internal
     // Dzongkhag ID — not user-facing
  eccd_id: false,           // ECCD center ID — backend use
  grade_id: false,          // Raw grade ID, not label
  student_id_user_profile: false, // redundant with user.student_id
  user_profile_picture: false,    // might be hidden if not displaying images

  // UI-SPECIFIC
  slNo: true,               // usually shown
  name: true,               // should be visible
  gender: true,             // likely relevant
  dob: false,               // sensitive
  status: true,             // active/inactive
  category: true,           // "Student", etc.
  mobile_no: true,          // useful for contact
  email: true,
  login_id: true,          // could be internal system ID
  action: true,             // needed for buttons
  dzongkhag_id: true, 
};
